let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8w3tW")).then(() => parcelRequire('2F04t'));